import React, { Component } from 'react';

import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Button from 'react-bootstrap/Button';
import { withRouter } from '../withRouter';
import { withTheme } from '../withTheme';
import { ArrowLeftShort } from 'react-bootstrap-icons';

class PresenterNavBar extends Component {
  state = {
    imageLoaded: false,
    imageError: false,
  };

  handleImageLoad = () => {
    this.setState({ imageLoaded: true, imageError: false });
  };

  handleImageError = () => {
    this.setState({ imageLoaded: false, imageError: true });
  };

  render() {
    const { imageLoaded, imageError } = this.state;
    const hasValidImage = this.props.img && imageLoaded && !imageError;

    return (
      <Navbar style={{ backgroundColor: this.props.backgroundColor }}>
        <Container className='d-flex align-items-center gap-3'>
          {this.props.goBack == true && (
            <Button
              variant='outline-dark me-2'
              size='sm'
              onClick={() => window.history.back()}
              style={{ color: 'var(--light)' }}
            >
              <ArrowLeftShort />
            </Button>
          )}
          {/* Keep the image mounted (even before it loads) so onLoad can fire */}
          {this.props.img && (
            <Navbar.Brand
              className='fw-bold m-0'
              style={{
                color: 'var(--light)',
                display: hasValidImage ? 'block' : 'none',
              }}
            >
              <img
                onLoad={this.handleImageLoad}
                onError={this.handleImageError}
                alt=''
                style={{
                  objectFit: 'contain',
                  maxWidth: '100%',
                  display: 'block',
                }}
                src={this.props.img}
                height='40'
                className='d-inline-block'
              />
            </Navbar.Brand>
          )}
          <Navbar.Text className='fw-bold' style={{ color: 'var(--light)' }}>
            {this.props.text}
          </Navbar.Text>
        </Container>
      </Navbar>
    );
  }
}

export default withRouter(withTheme(PresenterNavBar));
